import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

import * as Sentry from '@sentry/angular';

if (environment.production) {
  enableProdMode();
  Sentry.init({
    dsn: 'https://50d3e62192774c70b89d8023a331c412@o460562.ingest.sentry.io/6082334',
    integrations: [],
    release: environment.version,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    // tracesSampleRate: 1.0,
  });
}

console.log(`%cBuild version: ${environment.version}`, 'font-weight: bold;');

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));

// replace urls in index.html
const links = Array.from(document.head.querySelectorAll('link'));
links.forEach(link => {
  link.href.replace('./assets', environment.deploy_url);
});
